export default "چطور\nچرا\nچقدر\nچه موقعی\nچند تا\nاز کجا\nآیا\nچه\nچه چیزی\nچه کسی\nچگونه\nکجا\nکدام\nکدوم\nکی\nدلیل\nتفاوت\nفرق\nچه زمانی\nچه وقتی"